import { AlarmClock, BarChart3, BookOpen, Blocks, Brain, Braces, Briefcase, Car, Cloud, Compass, Contact, Flame, Folder, FolderOpen, FileText, GitBranch, Globe, Handshake, Hourglass, Image, Inbox, Library, ListChecks, Mail, MessageCircle, OctagonX, Package, Paperclip, Pencil, Play, Plug, Plus, Search, Send, Share2, ShoppingCart, Shuffle, SquareTerminal, CircleDot, CircleHelp, ClipboardList, Wrench, type LucideIcon } from 'lucide-react';

/** The web's tool marks. Manifests, the daemon payloads, the CLI and the chat platforms keep declaring an
 *  emoji per tool; the web never prints it and instead maps each declared emoji through this closed table
 *  (every emoji a bundled or registry manifest or `BUILTIN_TOOL_ICONS` declares; `toolMeta.test.ts` guards
 *  the bundled ones). Keys are written without the variation selector, which `toolIcon` strips. A
 *  closed map, not a dynamic `lucide-react` lookup, so the bundle stays tree-shakeable. */
const DECLARED: Record<string, LucideIcon> = {
  '🔥': Flame, '🧠': Brain, '🧭': Compass, '🖼': Image, '📎': Paperclip, '📋': ClipboardList, '📁': Folder,
  '🔌': Plug, '📖': BookOpen, '🧩': Blocks, '🤝': Handshake, '⏳': Hourglass, '📥': Inbox, '✉': Mail,
  '🛑': OctagonX, '🔀': Shuffle, '➕': Plus, '📊': BarChart3, '▶': Play, '💻': SquareTerminal, '❓': CircleHelp,
  '📄': FileText, '📂': FolderOpen, '✏': Pencil, '🌿': GitBranch, '🔍': Search, '🔎': Search, '🌐': Globe,
  '𝚓𝚜': Braces, '💼': Briefcase, '☁': Cloud, '⏰': AlarmClock, '📚': Library, '🚗': Car, '🛒': ShoppingCart,
  '📦': Package, '💬': MessageCircle, '📇': Contact, '✈': Send, '🟢': CircleDot,
};

/** Names the core owns a mark for. Plugin tools supply their declared emoji through the existing
 *  payloads; without one, an unknown name gets the neutral wrench rather than a guess. */
const EXACT: Record<string, LucideIcon> = {
  DocsSearch: BookOpen, SkillLoad: BookOpen, ExitPlanMode: ListChecks,
  ShareFile: Share2, ShareImage: Share2,
  MemoryAdd: Brain, MemorySearch: Brain, MemoryUpdate: Brain, MemoryDelete: Brain,
  MemoryMerge: Brain, MemoryListRecent: Brain, MemoryRecategorize: Brain,
};

/** The one tool-mark resolver: a declared emoji maps through `DECLARED` (an emoji the table does not know
 *  is the neutral wrench, never text); no declaration falls back to the core-owned mark for `name`. */
export function toolIcon(name: string, declared?: string | null): LucideIcon {
  if (declared) return DECLARED[declared.replaceAll('\uFE0F', '')] ?? Wrench;
  const exact = EXACT[name];
  if (exact) return exact;
  if (name.startsWith('Memory')) return Brain;
  return Wrench;
}

/** Test seam: the declared emoji the table covers.
 *  @internal */
export const DECLARED_TOOL_EMOJI: readonly string[] = Object.keys(DECLARED);

/** Drop the MCP namespace for display; the full tool name stays in the title attribute. */
export function shortToolName(name: string): string {
  const parts = name.split('__');
  return parts[parts.length - 1] || name;
}
